import { fg } from '@atlaskit/platform-feature-flags';
import { useRovoContext } from '../rovo-context/rovo-context';
import { useUserContext } from '../user-context/user-context';

export const useShowAtlassianHomeSearchLink: (primaryProduct?: string) => boolean = (primaryProduct?: string) => {
	const { isRovoEnabled } = useRovoContext();
	const { orgId } = useUserContext();
	return showAtlassianHomeSearchLink(isRovoEnabled, orgId, primaryProduct);
};

export const showAtlassianHomeSearchLink: (isRovoEnabled?: boolean, orgId?: string, primaryProduct?: string) => boolean = (
	isRovoEnabled?: boolean,
	orgId?: string,
	primaryProduct?: string,
): boolean =>
	!!(isRovoEnabled && orgId && primaryProduct === 'jira' && fg('jira_rovo_in_quick_search'));
